<template>
  <section>
    <b-row >
      <b-col class="box-effect linear"
        >
            <b-card 
              >   
                <template v-slot:header >
                  <div class="header-card  text-left">
                    Registros de afiliaciones
                    <b-button size="sm" @click="nuevoModal()" variant="outline-primary" style="float:right">Crear registro</b-button>
                   </div> 
                </template> 
                <sw-tableget 
                    :warningClass="warningClass"
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="tableGet"
                    route="get_aflregistros"
                    :dataRoute="{inicial: fecha().fecha.minHoy, final: fecha().fecha.minHoy, others: []}"
                    @filtrar="getFiltrar"
                    @limpiar="getLimpiar"
                    @pdf="getPdf"
                    @save="saveForm"
                    >    
                    <template v-slot:filtrar>
                      <b-row style="margin-bottom:5px
                      ;padding:15px;border: 1px ridge;background: rgba(0, 80, 166, 0.03);">
                        <b-col :md="4">                          
                          <b-input-group class="filter-sw-group" size="sm" prepend="Desde:" style="margin-bottom:5px">
                            <input type="date" v-model="filter.inicial">
                          </b-input-group>  
                          <b-input-group class="filter-sw-group" size="sm" prepend="Hasta :" >
                            <input type="date" v-model="filter.final">
                          </b-input-group>   
                        </b-col>        
                        <b-col :md="4">                          
                          <b-input-group  class="filter-sw-group" size="sm" prepend="Asesor">
                            <c-multiselect
                              style="display:inline-block;flex: 1 1 0%"   
                              v-model="filter.id_datos_asesor"                   
                              :options="filterSelects('datos_asesor')"
                              label="name"
                              track-by="name"
                              :preselect-first="false"
                              :searchable="false"
                              placeholder="Seleccionar"
                              >
                              </c-multiselect>
                          </b-input-group> 
                          </b-col>
                      </b-row>                      
                    </template>                       
                    <template v-slot:modal>                      
                      <sw-modalafldescargar 
                        v-if="openModal.modal.modal==='Editar'"
                        @save="saveForm">
                      </sw-modalafldescargar>
                      <sw-modalanularregistro 
                        v-if="openModal.modal.modal==='Anular'"
                        @save="saveForm">
                      </sw-modalanularregistro>
                    </template>   
                </sw-tableget>  
            </b-card>           
      </b-col>      
    </b-row>     
    <b-modal 
          v-if="openModal.modal.modal==='Nuevo'"
          v-model="openModal.modal.value"
          :title="openModal.modal.title" 
          :header-bg-variant="'primary'"
          header-text-variant="light"
          :hide-footer="true"  
          :no-close-on-backdrop="true" 
          size="lg"  
          >        
            <sw-modalregistro 
              @save="saveForm"                     
              >
            </sw-modalregistro>      
        </b-modal>   
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex"
import indexMix    from './indexMix.js'
import storeMix    from './storeMix.js'
import tableMix    from './tableMix.js'
import saveMix     from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import SwModalanularregistro from '@/components/modals/anularRegistro.vue'
import SwModalafldescargar from '@/components/modals/aflDescargar.vue'
import SwModalregistro from '@/components/modals/registro.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: "afiliacion_informes",
  components: { 
    SwTableget,
    SwSearchs,
    SwModalafldescargar,
    'c-multiselect': Multiselect,
    SwModalanularregistro,
    SwModalregistro
  },
  mixins: [indexMix, storeMix, tableMix, saveMix, saveMixins,],
};
</script>
